import Keycloak from "keycloak-js";

const keycloakConfig = new Keycloak({
	url: process.env.REACT_APP_KEYCLOAK_URL,
	realm: process.env.REACT_APP_KEYCLOAK_REALM,
	clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
});

const initOptions = {
	onLoad: 'check-sso',
	checkLoginIframe: false ,
	pkceMethod: 'S256',
	enableLogging: true,
	responseMode: 'fragment',
	useNonce: false
};

export { keycloakConfig, initOptions }
